import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';

export interface ITeamMember {
	image?: IImage;
	name: string;
	title?: string;
	link?: ILink
}

export interface ITeamProps extends IBaseElementProps {
	teamMembers: ITeamMember[];
}

/**
 * Displays a list of team members
 * @block
 */

const Team: React.FC<ITeamProps> = ({
	teamMembers = [],
	className,
	classNames = [],
}) => (
	<div
		className={
			className || cn('team', 'container-fluid', ...classNames)
		}
	>
		<div className="team__wrapper">
			{teamMembers.length > 0 && teamMembers.map(({ image, name, title, link }, i) => (
				<a {...link} className="team-card">
					{image && (
						<Image {...image} className="team-card__image" />
					)}
					<div className="team-card__content">
						<h3>{name}</h3>
						{title && <p>{title}</p>}
					</div>
				</a>
			))}
		</div>
	</div>
);

export default Team;
